/**
 * Combines class names conditionally
 * @param classes - Array of class names or conditional class names
 * @returns Combined class name string
 */
export function cn(...classes: (string | undefined | null | false)[]): string {
	return classes.filter(Boolean).join(" ");
}
